import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import uuid from 'uuid'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskParticipantEdit } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button, Status } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import { CONSENT_DELIVERY_TYPES } from 'constants/enums'
import config from 'config'

export default class TasksAwardsRegistrationTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onRegistrationAwardEdit: PropTypes.func.isRequired,
    deleteParticipantRegistration: PropTypes.func.isRequired,
    approveModal: PropTypes.func.isRequired
  }

  state = {
    awardIdRegistration: null,
    awardId: null,
    participantPersonDetail: null,
    awardDetail: null
  }

  key = uuid.v1()

  handleEditModal = (awardDetail, awardId, participantPersonDetail) => {
    this.setState(
      {
        awardDetail,
        participantPersonDetail,
        awardId
      },
      () => {
        this.props.modal('modal-edit')
      }
    )
  }

  handleApproveModal = awardIdRegistration => {
    this.setState(
      {
        awardIdRegistration
      },
      () => {
        this.props.modal(`modal-signoff-activity-${this.key}`)
      }
    )
  }

  render() {
    const { data, approveModal } = this.props

    let isBlocked =
      !get(data, 'isPaymentConfirmed') ||
      !get(data, 'participant.isEmailConfirmed')

    if (get(data, 'consentDeliveryType.value') !== CONSENT_DELIVERY_TYPES.notRequired.id) {
      isBlocked = isBlocked || !get(data, 'isConsentDeliveryConfirmed')
    }

    return (
      <div>
        <Table ths={tasksLayout.awardsRegistrationsSingle}>
          <Data>
            <tr>
              <td>
                <Link to={`${config.publicPath}/participants/${get(data, 'participant.id')}`}>
                  {get(data, 'participant.globalId') ||
                    get(data, 'participant.id')}
                </Link>
              </td>
              <td>{get(data, 'participant.firstName')}</td>
              <td>{get(data, 'participant.lastName')}</td>
              <td>
                {get(data, 'participant.email')}
                <Status
                  state={get(data, 'participant.isEmailConfirmed')}
                  check
                  inline
                  toRight
                />
              </td>
              <td>
                {get(data, 'consentDeliveryType.translationText')}
                {get(data, 'consentDeliveryType.value') !==
                  CONSENT_DELIVERY_TYPES.notRequired.id
                  ? <Status
                      state={get(data, 'isConsentDeliveryConfirmed')}
                      check
                      inline
                      toRight
                    />
                  : <Status state check inline toRight />}
              </td>
              <td>
                {get(data, 'paymentState.translationText') || '---'}
                <Status
                  state={get(data, 'isPaymentConfirmed')}
                  check
                  inline
                  toRight
                />
              </td>
              <td>
                <Button
                  onClick={() =>
                    this.handleEditModal(
                      data,
                      get(data, 'id'),
                      data.participant
                    )}
                  tiny
                >
                  <FormattedMessage
                    id="button.confirm"
                    defaultMessage="confirm"
                  />
                </Button>
              </td>
              <td className="text--right">
                <ButtonGroup right>
                  <Button
                    type="button"
                    onClick={() => this.handleApproveModal(get(data, 'id'))}
                    intlKey="button.approve"
                    disabled={isBlocked}
                    small
                  >
                    Approve
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal id="modal-edit" customActions>
          <TaskParticipantEdit
            key={this.state.awardId}
            award={this.state.awardDetail}
            awardId={this.state.awardId}
            person={this.state.participantPersonDetail}
            onRegistrationDelete={this.props.deleteParticipantRegistration}
            onEditSubmit={this.props.onRegistrationAwardEdit}
          />
        </Modal>
        <Modal id={`modal-signoff-activity-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.awardIdRegistration}
            modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}
